import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getcarrentalPackageList } from "../store/slices/carrentalpackage";
import HTMLRenderer from "./render";

const CarRentalPackageDetails = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [duration, setDuration] = useState("");
  const [places, setPlaces] = useState([]);
  const [packageName, setpackageName] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const data = await dispatch(getcarrentalPackageList({ id })).unwrap();
        const packagedata = data?.packageData[0];

        const clonedPackages = (packagedata.packages || []).map(
          (item, index) => ({
            ...item,
            id: `${Date.now()}-${index}`,
            range: item.range,
            price: item.price,
            entryFees: item.entryFees,
          }),
        );
        setpackages(clonedPackages);
        setpackageName(packagedata.packageName);
        setDuration(packagedata.duration);
        setDescription(packagedata.description);
        setImages(packagedata.images);

        const formattedPlaces = (packagedata.places || []).map((place) => ({
          placeId: place.placeId,
          name: place.name,
        }));
        setPlaces(formattedPlaces);
      } catch (error) {
        console.error("Error fetching package details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPackageDetails();
  }, [dispatch, id]);

  const [packages, setpackages] = useState([
    {
      id: Date.now(),
      name: "",
      minMember: "",
      priceperPerson: "",
      priceperChild: "",
    },
  ]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Package Details</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/carrental"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Packages
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Car Rental Package Details</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row mb-40">
            <div className="col-md-5">
              <label className="form-label">Package Name</label>
              <p>{packageName}</p>
            </div>

            <div className="col-md-5 mt-3">
              <label className="form-label">Duration</label>
              <p>{duration}</p>
            </div>

            <div className="col-md-12 mt-3">
              <label className="form-label">Places</label>
              <div className="row mt-3">
                {places?.map((place) => (
                  <div
                    className="col-md-3 m-2"
                    style={{
                      background: "rgb(247,146,29)",
                      borderRadius: "5px",
                      color: "#fff",
                    }}
                  >
                    {place.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Images</label>
              <div className="row mt-3">
                {images?.map((img, index) => (
                  <div className="col-md-2 mb-2 position-relative" key={index}>
                    <img
                      src={img.mediaLink}
                      style={{ height: "120px", objectFit: "cover" }}
                      alt=""
                      className="img-thumbnail"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Description</label>

              <p className="mt-25">
                <HTMLRenderer htmlContent={description} />
              </p>
            </div>
            <div className="col-md-11 mt-3">
              <label className="form-label">Packages</label>
              <div className="question-form">
                {packages?.map((item) => (
                  <div key={item.id} className="container border mb-3 rounded">
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label">Members</label>
                        <p>{item.range}</p>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Vehicle Name</label>
                        <p>{item.vehicleName}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Price</label>
                        <p>{item.price}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Entry Fee</label>
                        <p>{item.entryFees}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarRentalPackageDetails;
